import { SET_OTHER_PERMISSIONS } from './types';

export const setOtherPermissions = otherPermissions => ({
  type: SET_OTHER_PERMISSIONS,
  otherPermissions,
});
